"use client";

import styled from "styled-components";
import { sans as zoram, lineHeightLoose, fontSize16, fontWeightNormal, fontWeightBold } from "@churchofjesuschrist/eden-style-constants";
import shared from "./shared";
import { jsx as _jsx } from "react/jsx-runtime";
const Container3 = styled.div.withConfig({
  componentId: "sc-1szn76m-0"
})(["font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";& b,& strong{font-weight:", ";}"], zoram, fontWeightNormal, lineHeightLoose, fontSize16, shared, fontWeightBold);

/**
 * `Text3` (Body Condensed) is used for long-form reading when using Condensed spacing.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - Text content
 * @param {React.ElementType} [props.renderAs] - HTML tag or custom React element to render as
 * @returns {React.ReactElement} The Text3 component
 */
const Text3 = ({
  children,
  renderAs = "div",
  ...props
}) => /*#__PURE__*/_jsx(Container3, {
  as: renderAs,
  ...props,
  children: children
});
Text3.displayName = "Text3";
export default Text3;